import { SxProps, Theme } from '@mui/system';
import ThemeConstants from '../../../theme/ThemeConstants';

const styles = {
  image: {
    height: '75px',
    width: '75px',
    border: `2px solid ${ThemeConstants.common.border}`,
  },

  avatarContainer: {
    display: 'flex',
    position: 'relative',
  },

  favIconContainer: {
    position: 'absolute',
    top: 50,
    left: 50,
    zIndex: 1,
  },

  infoContainer: {
    flex: 1,
    marginLeft: '16px',
  },

  gutter: {
    paddingBottom: '16px',
  },

  title: {
    fontWeight: 600,
    lineHeight: '30px',
    fontSize: '20px',
    color: 'common.grey850',
    marginRight: '10px',
  },

  addressText: {
    fontSize: '14px',
    fontWeight: 400,
    color: 'common.grey850',
  },

  date: {
    lineHeight: '21px',
    fontSize: '14px',
    fontWeight: 400,
    color: 'common.grey850',
  },

  rangeLabel: {
    my: '4px',
  },

  cardContent: {
    display: 'flex',
    flex: 1,
  },

} satisfies Record<string, SxProps<Theme>>;

export default styles;
